import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IBroadcast } from "src/app/models/broadcast";
import { ConfigurationSettings } from "src/app/models/configuration.settings";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class BroadcastService {
  constructor(
    private http: HttpClient,
    private configurationSettings: ConfigurationSettings
  ) {}
  //Create / Update broadcast
  CreateBroadcast(broadcast: IBroadcast): Observable<any> {
    return this.http.post<IBroadcast>(
      this.configurationSettings.broadcast_api_endpoint + "/CreateBroadcast",
      broadcast
    );
  }
  //Activate Broadcast
  ActivateBroadcast(broadcastId: number): Observable<any> {
    return this.http.post<number>(
      this.configurationSettings.broadcast_api_endpoint + "/ActivateBroadcast",
      broadcastId
    );
  }
  //Activate Broadcast
  DectivateBroadcast(broadcastId: number): Observable<any> {
    return this.http.post<number>(
      this.configurationSettings.broadcast_api_endpoint + "/DectivateBroadcast",
      broadcastId
    );
  }
  //Get all Broadcasts
  GetAllBroadcasts(botConfigId: number): Observable<any> {
    return this.http.get(
      this.configurationSettings.broadcast_api_endpoint +
        "/GetAllBroadcasts?botConfigId=" +
        botConfigId
    );
  }
  //Get Broadcast by broadcastId
  GetBroadcast(broadcastId: number): Observable<any> {
    return this.http.get(
      this.configurationSettings.broadcast_api_endpoint +
        "/GetBroadcast?broadcastId=" +
        broadcastId
    );
  }
  //Schedule a Broadcast
  ScheduleBroadcast(broadcastId: number): Observable<any> {
    return this.http.post<number>(
      this.configurationSettings.broadcast_api_endpoint + "/ScheduleBroadcast",
      broadcastId
    );
  }

  //InitiateBroadcast
  TriggerBroadcast(broadcastId: number): Observable<any> {
    return this.http.post<number>(
      this.configurationSettings.broadcast_api_endpoint + "/TriggerBroadcast",
      broadcastId
    );
  }

  //Get All BotAccessed Users
  GetAllBotAccessedUsers(botConfigId: number): Observable<any> {
    return this.http.get(
      this.configurationSettings.broadcast_api_endpoint +
        "/GetAllBotAccessedUsers?botConfigId=" +
        botConfigId
    );
  }
}
